






















import Vue from "vue";

import IconClose from "../../assets/icons/black/Close.svg";

export default Vue.extend<{}>({
  name: "JzTitle",
  functional: true,
  props: {
    rightSideIcon: { type: String, default: IconClose },
  },
});
